import type { ForgotPasswordConfig } from '#types/config/components/form/forgotPassword'

export default {
  brandClasses: {
    heading: 'subtitle-4'
  }
} satisfies ForgotPasswordConfig
